import logo from '../assets/logo-widya-cendekia.png'

interface LogoProps {
  compact?: boolean;
  subtitle?: string;
  title?: string;
  theme?: 'light' | 'dark' | 'auto';
}

export function Logo({
  compact = false,
  subtitle = 'Sekolah Islam Terpadu',
  title = 'Widya Cendekia',
  theme = 'auto',
}: LogoProps) {
  return (
    <div className="flex items-center gap-3">
      <img
        src={logo}
        alt="Logo Sekolah Islam Terpadu Widya Cendekia"
        width={compact ? 40 : 48}
        height={compact ? 40 : 48}
        className={compact ? 'h-10 w-10 rounded-xl object-contain' : 'h-12 w-12 rounded-2xl object-contain'}
      />
      {!compact && (
        <div className="leading-tight">
          <p className="text-[10px] font-extrabold uppercase tracking-[0.18em] text-teal-600 dark:text-teal-400">
            {subtitle}
          </p>
          <p
            className={`text-base font-black tracking-tight ${
              theme === 'dark'
                ? 'text-white'
                : theme === 'light'
                ? 'text-slate-900'
                : 'text-slate-900 dark:text-white'
            }`}
          >
            {title}
          </p>
        </div>
      )}
    </div>
  )
}
